import React from 'react'
import { useNavContext } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/useNavContext'
import useWindowSize from '@toasttab/shared/src/hooks/useWindowSize'
import MobileChildMenu from '@toasttab/shared/src/components/organisms/Navigation/Contentful/Mobile/MobileChildMenu'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { MobileRegionMenuProps } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'

const MobileRegionMenu = ({
  localizeRegionLinks,
  handleAfterSubmitting,
  localizedEntries,
  packageObj,
  sitesByContinent
}: MobileRegionMenuProps) => {
  const { t } = useI18next()
  const {
    isRegionMenuOpen,
    setIsMobileNavOpen,
    setIsOverlayOpen,
    setIsRegionMenuOpen
  } = useNavContext()
  const windowSize = useWindowSize()
  const isMobileLayout = windowSize.width < 1024

  const handleBackButton = () => {
    setIsRegionMenuOpen(false)
  }
  const handleCloseButton = () => {
    setIsMobileNavOpen(false)
    setIsOverlayOpen(false)
    setIsRegionMenuOpen(false)
  }

  return (
    <MobileChildMenu
      ariaLabel='Toast Region Switcher Menu'
      handleBackButton={handleBackButton}
      handleCloseButton={handleCloseButton}
      id='nav-region-menu-mobile'
      isOpen={!!(isRegionMenuOpen && isMobileLayout)}
      title={t('Choose your region')}
    >
      {Object.keys(sitesByContinent).map((continent) => {
        const localizedLinks = localizeRegionLinks({
          localizedEntries,
          packageObj,
          sites: sitesByContinent[continent]
        })
        return (
          <ul key={`${continent}-mobile`}>
            {localizedLinks.map((regionLink: any) => (
              <li className='mt-4' key={`${regionLink.language}-mobile`}>
                <button
                  className='font-effra text-base text-default font-normal hover:text-blue-75 hover:font-semibold'
                  onClick={() => handleAfterSubmitting(regionLink.url)}
                >
                  {t(regionLink.language)}
                </button>
              </li>
            ))}
          </ul>
        )
      })}
    </MobileChildMenu>
  )
}

export default MobileRegionMenu
